<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(submit)" class="text-black-form" v-loading="saving">
        <div style="font-weight: bold;font-size: 25px;">{{ accommodation.code }} - {{ form.tickets.length }} TICKETS</div>
      <div v-for="(ticket,i) in form.tickets" :key="i">
        <TicketWithSeatNumber :ticket="ticket" @update="setTicket($event, ticket)" :booking="booking" @remove="handleRemove"></TicketWithSeatNumber>
      </div>
      <hr>
      <div style="font-size: 25px;font-weight: bolder;text-align: center;">
            <div >TOTAL: {{ money( total ) }}</div>
            <div class="line-box" v-if="total > 0">
                 <!-- <ConfirmButton title="You're about to save this transaction. Ready to proceed?" label="SAVE & PRINT"
                       type="primary" :icon="'fa fa-save'" class="mr-2" size="default"
                      @onClick="handleSave">
                    </ConfirmButton> -->
                  <el-button type="primary" @click="handleShowPassengerNames">NEXT</el-button>
            </div>
        </div>
        <el-drawer title="" :visible.sync="showPdf" direction="btt" :before-close="handleClose" size="90%"
      :append-to-body="true" :destroy-on-close="true">
      <TicketPdfViewer :url="url" v-if="url" @print="handleClose"></TicketPdfViewer>
    </el-drawer>

    </form>

    <el-drawer title="" :visible.sync="showPassengerNames" direction="btt" :before-close="handleClosePassengersName" size="90%"
        :append-to-body="true" :destroy-on-close="true">
        <FillUpTicketsWithNameForm :form="form" @submit="handleSave" :booking="booking"></FillUpTicketsWithNameForm>
    </el-drawer>

  </ValidationObserver>
</template>

<script>
import {
  extend
} from "vee-validate";
import {
  required
} from "vee-validate/dist/rules";
import {
  Ticket
} from '@/resources/ticket'

import TicketWithSeatNumber from "./TicketWithSeatNumber.vue";
import ConfirmButton from "../../../Common/ConfirmButton.vue";
import TicketPdfViewer from "../../Ticketing/TicketPdfViewer.vue";
import FillUpTicketsWithNameForm from "./FillUpTicketsWithNameForm.vue";

extend("required", required);

export default {
    components: { TicketWithSeatNumber, ConfirmButton, TicketPdfViewer, FillUpTicketsWithNameForm },
    props: ['booking', 'accommodation'],
  data() {
    return {
      form: {
        tickets: []
      },
      saving: false,
      showPdf: false,
      url: null,
      showPassengerNames: false
    };
  },
  watch: {
    accommodation: function(){
        this.init()
    }
  }, 
  created: function () {
    this.init()
  },
  computed: {
    total() {
        let sum = 0;
        this.form.tickets.forEach( ticket=> {
            sum += ticket.total_fare
        })

        return sum
    },
  },
  methods: {
    handleClosePassengersName() {
        this.showPassengerNames = false
    },
    handleClose() {
        this.showPassengerNames = false
        this.showPdf = false
        this.$emit('refresh')
    },
    handleShowPassengerNames() {
        this.showPassengerNames = true
    },
    handleSave(form) {

      this.$loading = true
      this.$loadingText = "Preparing to generate ticket"

      Ticket.saveOnBoardTickets(form)
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Transaction has been completed. Printing the tickets',
          });

          this.url = result.data.url
          this.showPdf = true
        })
        .catch(() => {

        }).finally(() => {
          this.$loading = false
        })
    },
   handleRemove(ticket) {
        this.form.tickets = this.form.tickets.filter(t => t.seat_number !== ticket.seat_number);
        this.$emit('remove', ticket.seat_number)
    },
    setTicket(data, ticket) {
        let index = null
        this.form.tickets.forEach( (t,i)=> {
            if (t.seat_number == ticket.seat_number) {
                index = i
            }
        })

        if (index != null) {
            this.form.tickets[index].passenger_type = data.passenger_type
            ticket.total_fare = data.total_fare
        }
    },
   init() {
    let tickets = []
    let self = this
    this.accommodation.selected_seats.forEach(seat => {
        let ticketData = {
            accommodation_id: self.accommodation.id,
            seat_number: seat,
            passenger_type: 0,
            total_fare: self.getFare(0),
            booking_id: self.booking.id
        }
        tickets.push(ticketData)
    });
    this.form.tickets = tickets
   },
   getFare(passenger_type) {
        let self = this
        let amount = 0
        this.booking.prices.forEach(price => {
            if (price.accommodation_id == self.accommodation.id && price.passenger_type == passenger_type) {
                amount = price.total_fare
            }
        })

        return amount
    }
  }
}
</script>

<style>

</style>

